<template>
  <div class="home">
    <!-- 音符装饰 -->
    <div class="music-notes">
      <div class="note note1">♪</div>
      <div class="note note2">♫</div>
      <div class="note note3">♩</div>
      <div class="note note4">♬</div>
      <div class="note note5">♪</div>
    </div>

    <div class="container-box activity-info">

      <div class="index_title index_title1"></div>
      <div class="index_tab_box">
        <div class="index_tab index_tab1" @click="checkLoginAndNavigate"></div>
        <div class="index_tab index_tab2" @click="checkLoginAndNavigate"></div>
      </div>
      <div class="index_top_box">
        <img src="@/assets/index_tit_1.png" alt="">
        <div class="index_top_msg1">高校全日制在校学生</div>
        <img src="@/assets/index_tit_2.png" alt="">
        <div class="index_top_msg2">2025年5月-2025年12月</div>
      </div>
      <div class="index_title index_title2"></div>
      <div class="index_msg_box">
        <div class="index_msg">
          <p class="index_msg_title">组织创作(2025年5月-10月15日)</p>
          <p class="index_msg_content">各高校根据通知要求广泛宣传、组织参与</p>
        </div>
        <div class="index_msg">
          <p class="index_msg_title">作品宣传(2025年5月20日-10月15日)</p>
          <p class="index_msg_content">所有参加活动的网络作品均需上传至抖音、哔哩哔哩、微博、微信公众号、视频号、小红书等新媒体平台。上传至抖音或哔哩哔哩的作品需参加“#大学生网络文化节”话题展示，并@“校园好网民”新媒体账号，承办单位和新媒体支持单位将择优进行热榜发布和宣传推广。</p>
        </div>
        <div class="index_msg">
          <p class="index_msg_title">作品上传开放时间</p>
          <p class="index_msg_content">2025年6月6日12:00</p>
        </div>
        <div class="index_msg">
          <p class="index_msg_title">上传作品截止时间</p>
          <p class="index_msg_content">2025年10月15日24:00</p>
        </div>
        <div class="index_msg">
          <p class="index_msg_title">作品遴选展示(2025年5月-12月)</p>
          <p class="index_msg_content">1.征集过程中综合参考作品浏览量等网络传播效果，对优秀作品进行全媒体展播。<br/>2.征集结束后组织邀请专家遴选优秀作品，并对遴选出的优秀作品进行全媒体展播。</p>
        </div>
      </div>
      <!--<h2 class="stars">争做校园好网民，汇聚网络正能量，前进强国之旅</h2>

       <div class="category-buttons">
        <button
          @click="checkLoginAndNavigate('/song-works/register')"
          class="category-button song"
        >
          <span class="icon">🎙️</span>
          校园歌曲作品
        </button>
        <button
          @click="checkLoginAndNavigate('/audio-works/register')"
          class="category-button audio"
        >
          <span class="icon">🎵</span>
          音频作品
        </button>
      </div>

      <h2>活动对象</h2>
      <p>高校全日制在校学生</p>

      <h2>活动时间</h2>
      <span class="time">2025年5月-2025年12月</span>

      <h2>高校参与活动流程</h2>
      <div class="timeline">
        <div class="timeline-item">
          <h3>组织创作(2025年5月-10月15日)</h3>
          <p>各高校根据通知要求广泛宣传、组织参与</p>
        </div>

        <div class="timeline-item">
          <h3>作品宣传(2025年5月20日-10月15日)</h3>
          <p>
            所有参加活动的网络作品均需上传至抖音、哔哩哔哩、微博、微信公众号、视频号、小红书等新媒体平台。上传至抖音或哔哩哔哩的作品需参加“#大学生网络文化节”话题展示，并@“校园好网民”新媒体账号，承办单位和新媒体支持单位将择优进行热榜发布和宣传推广。
          </p>
        </div>

        <div class="timeline-item">
          <h3>作品上传开放时间</h3>
          <p>2025年6月6日12:00</p>
        </div>

        <div class="timeline-item">
          <h3>上传作品截止时间</h3>
          <p>2025年10月15日24:00</p>
        </div>

        <div class="timeline-item">
          <h3>作品遴选展示(2025年5月-12月)</h3>
          <p>
            1.征集过程中综合参考作品浏览量等网络传播效果，对优秀作品进行全媒体展播。
          </p>
          <p>
            2.征集结束后组织邀请专家遴选优秀作品，并对遴选出的优秀作品进行全媒体展播。
          </p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { isMobileH5 } from "@/utils";

export default {
  name: "HomePage",
  methods: {
    async checkLoginAndNavigate() {
      this.$alert({
        className: "h5-alert",
        title: "提示",
        message:
          '<p>报名已结束！</p>',
        raw: true,
      });
      // 如果是移动端H5，直接跳转到移动端首页
      // if (isMobileH5()) {
      //   this.$alert({
      //     className: "h5-alert",
      //     title: "提示",
      //     message:
      //       '<p>上传作品请前往网页端进行报名！<br>网址：<a href="https://voice.yiban.cn/">https://voice.yiban.cn/</a>',
      //     raw: true,
      //   });
      // } else if (
      //   await this.$store.$getModel("user", {}, { apiAction: "auth" })
      // ) {
      //   // 登录成功，跳转到指定路由
      //   this.$router.push(route);
      // }
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/global";

.home {
  // padding: 20px;
  position: relative;
  overflow: hidden;
}


/* 音符动画 */
.music-notes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.note {
  position: absolute;
  font-size: 30px;
  opacity: 0;
  animation: float 15s linear infinite;
}

.note1 {
  top: 20%;
  left: 10%;
  color: global.$primary-color;
  animation-delay: 0s;
}

.note2 {
  top: 30%;
  left: 20%;
  color: global.$primary-color;
  animation-delay: 3s;
}

.note3 {
  top: 15%;
  right: 15%;
  color: global.$primary-color;
  animation-delay: 6s;
}

.note4 {
  top: 40%;
  right: 20%;
  color: global.$primary-color;
  animation-delay: 9s;
}

.note5 {
  top: 25%;
  left: 50%;
  color: global.$primary-color;
  animation-delay: 12s;
}

@keyframes float {
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100px) rotate(360deg);
    opacity: 0;
  }
}

.category-buttons {
  display: flex;
  justify-content: space-around;
  margin: 30px 0;
  gap: 50px;
  position: relative;
  z-index: 2;
}

.category-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 30px;
  border-radius: 30px;
  color: white;
  text-decoration: none;
  font-size: global.$button-font-size-xl;
  font-weight: bold;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border: none; /* 确保按钮没有边框 */
  cursor: pointer; /* 添加鼠标指针样式 */
}

.category-button .icon {
  margin-right: 10px;
  font-size: global.$font-size-l;
}

.category-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.category-button:hover::before {
  left: 100%;
}

.category-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
}

.song {
  background-color: global.$primary-color;
}

.audio {
  background-color: #6b66ff;
}

.activity-info {
  max-width: 1200px;
  // margin: 50px auto;
  background-color: #fff;
  padding: 45px 40px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.activity-info h2 {
  margin: 20px 0 10px;
  text-align: center;
  position: relative;
}

.activity-info h2::before,
.activity-info h2::after {
  content: "★";
  margin: 0 10px;
}

.activity-info h2.stars::before,
.activity-info h2.stars::after {
  content: "★★★";
}

.activity-info p {
  text-align: center;
  margin-bottom: 8px;
  color: #555;
}

.time {
  border-bottom: 3px solid global.$border-color;
  padding: 0 16px;
}

.timeline {
  margin-top: 30px;
}

.timeline-item {
  background-color: #ffd431;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
  position: relative;
}

.timeline-item::after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #ffd431;
}

.timeline-item:last-child::after {
  display: none;
}

.timeline-item h3 {
  text-align: center;
  margin-bottom: 10px;
  color: #333;
}

.timeline-item p {
  text-align: center;
  color: #555;
}

@media screen and (max-width: global.$tablet-breakpoint) {
  .category-buttons {
    display: flex;
    flex-direction: column;
  }
}
</style>